import React from "react";
import classNames from "classnames";
import "./index.scss";

import IntervalControl from "../IntervalControl";
import { getTranslateTitle } from '../../../utils/objects-util.js';

export default ({ column, value, onPropChange }) => {

    const handleOnPropChange = (val) => {
        if(column.isReadonly){
            return;
        }

        onPropChange({ [column.editableProp]: val });
    }

    return (
        <div className={classNames("sectionItemInterval")}>
            <div className={classNames("sectionItemIntervalLabel")}>
                {getTranslateTitle(column.title)}
            </div>
            <IntervalControl value={value} onChange={val=> handleOnPropChange(val)} />
        </div>
    );
} 